import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12} ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.radius.infoMessage};
  background-color: ${props => props.theme.colors.primary.surface};
`

export const Icon = styled.span`
  display: flex;
  flex-shrink: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`
